
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaUsers, FaEye, FaClock } from 'react-icons/fa';
import '../../../../assets/css/customer/publicCustomerCss/CusPackages/cuspackages.css';
import { useContext } from "react";
import AppContext from "../../../../context/AppContext";
 
const PackageCard = ({ packageData, onToggle, isExpanded, otherCardsShrink }) => {
    const navigate = useNavigate();
const { imageBaseUrl } = useContext(AppContext);
    const title       = packageData.package_name;
   const image = packageData.package_image
  ? `${imageBaseUrl}/${packageData.package_image}`
  : null;
    const price       = packageData.package_price;
    const days        = packageData.duration_days;
    const nights      = packageData.duration_nights;
    const location    = packageData.location || packageData.package_destination;
    const maxPeople   = packageData.max_people_size;
    const description = packageData.package_description;
    const category    = packageData.package_category;
    const available   = packageData.is_available !== false;
   

    const shortDesc = description
        ? description.length > 110
            ? description.slice(0, 110) + '…'
            : description
        : '';

    const featureTags = category ? [category] : [];

    const handleCardClick = (e) => {
        if (!e.target.closest('.pub-pack-view-detail-btn')) {
            onToggle(packageData.id);
        }
    };

    const handleViewDetails = (e) => {
        e.stopPropagation();
        navigate(`/packages/${packageData.id}`);
    };

    const cardClasses = [
        'pub-pack-package-card',
        isExpanded       ? 'expanded'     : '',
        otherCardsShrink ? 'shrink'        : '',
        !available       ? 'unavailable'   : '',
    ].filter(Boolean).join(' ');

    return (
        <div className="pub-pack-card-item">
            <div
                className={cardClasses}
                onClick={available ? handleCardClick : undefined}
                role="button"
                tabIndex={available ? 0 : -1}
                onKeyDown={e => available && e.key === 'Enter' && onToggle(packageData.id)}
                aria-expanded={isExpanded}
                aria-disabled={!available}
            >
                {!available && (
                    <div className="pub-pack-unavailable-badge">Unavailable</div>
                )}

                {category && (
                    <div className="pub-pack-package-badge">{category}</div>
                )}

                <div className="pub-pack-package-image-container">
                    {image ? (
                        <img
                            src={image}
                            className="pub-pack-package-img"
                            alt={title}
                            draggable="false"
                            loading="lazy"
                        />
                    ) : (
                        <div className="pub-pack-img-placeholder">
                            <FaMapMarkerAlt />
                        </div>
                    )}
                    <div className="pub-pack-package-overlay">
                        <h5 className="pub-pack-card-title">{title}</h5>
                    </div>
                </div>

                <div className="pub-pack-package-content">

                    <div className="pub-pack-price-section">
                        <div className="pub-pack-amount-box">
                            <small className="pub-pack-currency">PKR </small>
                            <span className="pub-pack-amount">{price || '—'}</span>
                        </div>
                        {(days || nights) && (
                            <div className="pub-pack-duration-text">
                                {days   && `${days}D`}
                                {days && nights && '/'}
                                {nights && `${nights}N`}
                            </div>
                        )}
                    </div>

                    {featureTags.length > 0 && (
                        <div className="pub-pack-features-tags">
                            {featureTags.map((tag, i) => (
                                <span key={i} className="pub-pack-feature-tag">{tag}</span>
                            ))}
                        </div>
                    )}

                    {isExpanded && (
                        <div className="pub-pack-package-details">
                            <div className="pub-pack-quick-info">
                                {location && (
                                    <div className="pub-pack-info-item">
                                        <FaMapMarkerAlt className="pub-pack-info-icon" />
                                        <span>{location}</span>
                                    </div>
                                )}
                                {maxPeople && (
                                    <div className="pub-pack-info-item">
                                        <FaUsers className="pub-pack-info-icon" />
                                        <span>Max {maxPeople} people</span>
                                    </div>
                                )}
                                {days && (
                                    <div className="pub-pack-info-item">
                                        <FaClock className="pub-pack-info-icon" />
                                        <span>
                                            {days} Days{nights ? ` / ${nights} Nights` : ''}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {shortDesc && (
                                <p className="pub-pack-desc-text">{shortDesc}</p>
                            )}

                            <button
                                className="pub-pack-view-detail-btn"
                                onClick={handleViewDetails}
                                aria-label={`View details for ${title}`}
                            >
                                <FaEye /> View Full Details
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PackageCard;